import { createEnvelopeSource } from './create-envelope-source';

/**
 * Carwash engagement source (`GET /analytics/carwash-engagement`). Three scalar
 * counts over the selected period.
 *
 * `regionGrain: 'national'` is load-bearing, not decoration: neither carwash
 * table carries a province, so the endpoint applies no region filter. One fetch
 * serves every region, and a per-region fan-out summed on top reads double.
 */
export const carwashEngagementSource = createEnvelopeSource({
    label: 'Carwash engagement',
    endpoint: 'analytics/carwash-engagement',
    metrics: [
        {
            id: 'washCodesGenerated',
            label: 'Wash code generated',
            type: 'scalar',
        },
        { id: 'beaconsGenerated', label: 'Beacon generated', type: 'scalar' },
        { id: 'beaconsRequested', label: 'Beacon requested', type: 'scalar' },
    ],
    forms: ['number'],
    regionGrain: 'national',
});
